import { store } from '../store'
window.addEventListener('online', () => {
  store.commit('setIsOnline', true)
})
window.addEventListener('offline', () => {
  store.commit('setIsOnline', false)
})



// WEBPACK FOOTER //
// ./src/lib/check-connection.js